module.exports = __webpack_public_path__ + "static/Michal-c61ab1b66efccfc31bd99078fadbf23b.mp4";